<div class="page-background">
  <div class="login-container">

    <div class="logo-container">
      <img src="assets/logo_beat.svg" alt="Logo Beat" class="logo">
    </div>

    <div class="login-header">
      <h2>{{'LOGIN.REGISTER' | translate }}</h2>
      <div class="separator">
        <span>{{ 'LOGIN.REGISTER_INFO' | translate }}</span>
      </div>
    </div>

    <form [formGroup]="userForm" class="user-form">

      <div class="form-group">
        <input type="text"
               class="form-input"
               formControlName="newUsername"
               placeholder="{{ 'LOGIN.USERNAME' | translate }}"
               [class.error]="(userForm.get('newUsername')?.hasError('required') || userForm.get('newUsername')?.hasError('emailAddressNotAllowed')) && userForm.get('newUsername')?.touched">
        <span class="error-message" *ngIf="userForm.get('newUsername')?.hasError('emailAddressNotAllowed') && userForm.get('newUsername')?.touched">
          {{ 'LOGIN.USERNAME_EMAIL_NOT_ALLOWED' | translate }}
        </span>
      </div>

      <div class="form-group">
        <input type="text"
               class="form-input"
               formControlName="newFullname"
               placeholder="{{ 'COMMON.NAME' | translate }}"
               [class.error]="userForm.get('newFullname')?.hasError('required') && userForm.get('newFullname')?.touched">
      </div>

      <div class="form-group">
        <input type="text"
               class="form-input"
               formControlName="newPhone"
               placeholder="{{ 'COMMON.PHONE_NUMBER' | translate }}"
               [class.error]="userForm.get('newPhone')?.hasError('required') && userForm.get('newPhone')?.touched">
      </div>

      <div class="password-container form-group">
        <input [type]="hidePassword ? 'password' : 'text'"
               class="form-input"
               formControlName="newPassword"
               placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
               [class.error]="userForm.get('newPassword')?.hasError('required') && userForm.get('newPassword')?.touched">
        <button type="button" class="password-toggle" (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>

      <button type="submit" class="login-button" (click)="onSubmit()">{{ 'COMMON.SAVE' | translate }}</button>

    </form>

  </div>
</div>